import {LOAD_PRODUCTS} from '../actions/types';

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = [], action) => {
    switch (action.type) {
        case LOAD_PRODUCTS:
            return action.payload;
        default:
            return state;
    }
};